import { useState } from "react";
import "../Contact.css"

const Contact = () => {
  const [status, setStatus] = useState("idle");
  const [result, setResult] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload

    setStatus("loading");
    setResult("Sending...");

    const formData = new FormData(e.target);
    formData.append("access_key", "5c9b3e7d-29c9-46d2-8243-309aa9a04e63");

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        setStatus("success");
        setResult("✅ Message sent successfully!");
        e.target.reset();

        // close modal after 2s (optional)
        if (window.UIkit) {
          setTimeout(() => {
            window.UIkit.modal("#modal-example").hide();
          }, 2000);
        }
      } else {
        setStatus("error");
        setResult("❌ Failed to send message.");
      }
    } catch (err) {
      setStatus("error");
      setResult("❌ Something went wrong.");
    }
  };

  return (
    <section className="contact">
      <form onSubmit={handleSubmit} method="POST" action="#">
        <h2>Contact Form</h2>

        <div className="input-box">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            className="field"
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="input-box">
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            className="field"
            placeholder="Enter your email"
            required
          />
        </div>

        <div className="input-box">
          <label>Your Message</label>
          <textarea
            name="message"
            className="field message"
            placeholder="Enter your message"
            required
          ></textarea>
        </div>

        <button type="submit" disabled={status === "loading"}>
          {status === "loading" ? "Sending..." : "Send Message"}
        </button>

        {result && (
          <p
            className={`form-result ${
              status === "success"
                ? "success"
                : status === "error"
                ? "error"
                : ""
            }`}
          >
            {result}
          </p>
        )}
      </form>
    </section>
  );
};

export default Contact;